import { FormChangeDetectionService } from '@/services/form-change-detection.service';
import { MessageCenterService } from '@/services/message-center.service';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

export const canDeactivateGuard: CanActivateFn = (route, state) => {
  const formService = inject(FormChangeDetectionService);
  const messageService = inject(MessageCenterService);
  const translate = inject(TranslateService);

  return new Promise<boolean>((resolve) => {
    if (formService.formArray.dirty) {
      messageService.confirm(
        translate.instant('general.confirmUnsavedChanges.header'),
        translate.instant('general.confirmUnsavedChanges.message'),
        () => {
          formService.formArray.reset(); // reset after user confirms
          resolve(true);
        },
        () => {
          resolve(false);
        }
      );
    } else {
      resolve(true);
    }
  });
};
